export default class CarCostHelpModal extends HTMLDivElement {


    connectedCallback() {

        this.addEventListener('show.bs.modal', e => {
            this.querySelector(".modal-body").innerHTML = e.relatedTarget.closest("[id^='step']").querySelector(".help-body").innerHTML;
        })
        
    }

}

customElements.define('car-cost-help-modal', CarCostHelpModal, { extends: 'div' });